import { atom, useSetAtom } from 'jotai';
import { useCallback } from 'react';

/** Current step (zero-indexed) for the two-step formula field form. */
export const formulaFieldFormStepState = atom<number>(0);

export function useResetFormulaFieldFormState() {
  const setCurrentStep = useSetAtom(formulaFieldFormStepState);

  return useCallback(() => {
    setCurrentStep(0);
  }, [setCurrentStep]);
}
